import React from 'react'
import ReactDOM from 'react-dom'
import { debounce, forEach } from 'lodash'
import { __, sprintf } from 'StylistParent/i18n'
import Dashicon from 'Components/dashicon'
import { getResponsiveValues } from 'Functions/get-responsive-values'

/* Import CSS */
import './index.scss'

class ResponsiveValueNotice extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			isEnabled: false,
			isOver: false,
			responsiveValues: []
		}
	}

	togglePopup = () => {
		this.setState( {
			isOver: ! this.state.isOver,
		} )
	}

	componentWillMount = () => {
		this.setState( {
			responsiveValues: getResponsiveValues( {
				cssProperty: this.props.cssProperty,
				cssSelectorCustom: this.props.cssSelectorCustom } )
		} )
	}

	render() {
		// const { type, name } = this.props;

		const media = '1024px'
		const responsiveValues = this.state.responsiveValues
		return (
			<div className="stlst-control--responsive-indicator"
				onMouseEnter={ ()=>{ this.togglePopup() } }
				onMouseLeave={ ()=>{ this.togglePopup() } }
			>
				<Dashicon
					icon="info-outline"
				/>
				{ this.state.isOver && <div className="stlst-control--responsive-indicator-message">
					{ /*__( 'The next media query overrides this value:' ) */ }
					{ __( 'Some media queries override this value:' ) }
					{ responsiveValues.map( function( item, idx ) {
						return ( <div key={ idx }><button
							type="button"
							// onClick={ this.props.onResponsiveModeToggle }
						> { /* __( 'Set to:' ) */ } <strong>{ item.value }</strong> <em>{ __( 'for' ) }</em> { item.label }</button></div> )
					}, this ) }
				</div> }
			</div>
		)
	}
}

export default ResponsiveValueNotice;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/responsive-value-notice/index.jsx